import { motion } from "framer-motion";
import ofuesiLogo from "@/assets/ofuesi-logo.png";

interface PageLoaderProps {
  message?: string;
  showNavigation?: boolean;
}

const PageLoader = ({ message = "Loading...", showNavigation = true }: PageLoaderProps) => {
  return (
    <div
      className={
        showNavigation
          ? "min-h-[calc(100vh-90px)] flex items-center justify-center"
          : "fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm"
      }
    >
      <div className="flex flex-col items-center gap-6">
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
            rotate: [0, 360],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="relative"
        >
          <img src={ofuesiLogo} alt="OFUESI Logo" className="w-24 h-24 object-contain" />
          <motion.div
            animate={{
              scale: [1, 1.5, 1],
              opacity: [0.5, 0.8, 0.5],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute inset-0 bg-primary/20 rounded-full blur-xl"
          />
        </motion.div>
        <motion.p
          animate={{
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="text-lg font-medium text-muted-foreground"
        >
          {message}
        </motion.p>
      </div>
    </div>
  );
};

export default PageLoader;
